module.exports = __webpack_public_path__ + "media/images/talent/feature-02-e2dcc50c01ff7ea82d5160cd13c14c0d.png";